import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const deleteSection = createAsyncThunk(
	"deleteSection",
	async ({ id, onSuccess }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.patch(`section/delete/${id}`);
			message.success("Section successfully deleted!");
			if (onSuccess) {
				onSuccess();
			}
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			message.error(err.response.data.message || "Failed to delete section");
			return rejectWithValue(err.response.data);
		}
	}
);

const sectionDeleteSlice = createSlice({
	name: "sectionDelete",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(deleteSection.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(deleteSection.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(deleteSection.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default sectionDeleteSlice.reducer;
